import { Component, inject, OnInit } from '@angular/core';
import { ApplicationInsightsService, AuthService, BreadcrumbService2, Claims, OrgSelectionService, Token, UserService, AppMenuService, UnsubscribeOnDestroy } from 'shared';
import { filter, map, Observable, takeUntil } from 'rxjs';
import { MenuItem } from 'primeng/api';
// import { PrimeNGConfig } from 'primeng/api'; // Commented out for PrimeNG v20 compatibility
import { Environment } from '../environments/environment';
import { RouterOutlet } from '@angular/router';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: true,
	imports: [RouterOutlet]
})
export class AppComponent extends UnsubscribeOnDestroy implements OnInit {
	private authService = inject(AuthService);
	private orgSelectionService = inject(OrgSelectionService);
	private breadCrumb = inject(BreadcrumbService2);
	private userService = inject(UserService);
	private applicationInsightsService = inject(ApplicationInsightsService);
	private appMenuService = inject(AppMenuService);
	
	Claims = Claims;
	token: Token;
	isLoggedIn: Observable<boolean>;
	selectedMarket: Observable<string>;
	items: Observable<MenuItem[]>;

	selectedMarketId: string;
	isMobile: boolean = false;
	isTablet: boolean = false;

	constructor() {
		super();
		this.isLoggedIn = this.authService.isUserLoggedIn();

		this.addGoogleAnalytics();
	}


	private addGoogleAnalytics() {
		let head = document.getElementsByTagName("head")[0];
		let script = document.createElement("script");
		script.async = true;
		script.src = Environment.googleAnalytics.tagManagerUrl;
		head.insertBefore(script, head.childNodes[0]);

		let script2 = document.createElement("script");
		script2.setAttribute('type', 'text/javascript');
		script2.innerHTML = Environment.googleAnalytics.gtagScript;
		head.insertBefore(script2, head.childNodes[1]);
	}



	ngOnInit(): void {
		this.setAppMenu();
	}

	private setAppMenu(): void {
		this.orgSelectionService.selectedMarket
			.pipe(
				takeUntil(this.ngUnsubscribe$),
				filter((m) => m !== null),
				map((m) => m.sourceKey)
			)
			.subscribe((res) => {
				this.selectedMarketId = res;
				this.addWindowChangeListener();
			});
	}

	addWindowChangeListener() {
		/* Add Media Queries matchMedia event listener to set properties based on screen width*/
		if (matchMedia) {
			const mq = window.matchMedia("(max-width: 576px)");
			const tq = window.matchMedia("(max-width: 1200px)");
			mq.addListener(this.onMobileMediaMatch.bind(this));
			tq.addListener(this.onTabletMediaMatch.bind(this));

			//call these intially so it gets set
			this.onMobileMediaMatch(mq);
			this.onTabletMediaMatch(tq);
		}
	}

	onMobileMediaMatch(mq: any) {
		this.isMobile = mq.matches;
		this.onWidthChange()
	}

	onTabletMediaMatch(tq: any) {
		this.isTablet = tq.matches;
		this.onWidthChange();
	}

	onWidthChange(): void {
		this.loadMenuModel();
	}

	loadMenuModel() {
		this.appMenuService.setAppMenu([
			{
				label: "Admin",
				icon: "fas fa-fw fa-cog",
				class: "hide-tablet",
				items: [
					{ label: "Subgroup Management", icon: "fas fa-fw fa-layer-group", routerLink: [`/home/admin/subgroups/${this.selectedMarketId}`], claims: [Claims.manage_subgroup], class: "hide-tablet" },
					{ label: "User Management", icon: "fas fa-fw fa-users-cog", routerLink: ["/home/admin/users/"], claims: [Claims.manage_user_settings], class: "hide-tablet", },
					{ label: "Community Management", icon: "fas fa-fw fa-sitemap", routerLink: [`/home/admin/communities/${this.selectedMarketId}`], claims: [Claims.community_management_edit], class: "hide-tablet", },
					{ label: "Market Management", icon: "fas fa-fw fa-globe-americas", routerLink: ["/home/admin/markets/"], claims: [Claims.orgAll, Claims.manage_markets], class: "hide-tablet", },
					{ label: "Division Reorg", icon: "fas fa-fw fa-exchange-alt", routerLink: ["/home/admin/divisionreorg/"], claims: [Claims.orgAll, Claims.manage_divisionreorg], class: "hide-tablet", }
				]
			}
		]);
	}
}
